import type {RefObject} from 'react';
import {useEffect, useRef} from 'react';
import {useEffectEventPatch} from './useEffectEvent';

export function useFormReset<T>(
  ref: RefObject<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  initialValue: T,
  onReset: (value: T) => void,
) {
  const resetValue = useRef(initialValue);
  const handleReset = useEffectEventPatch(() => {
    if (onReset) {
      onReset(resetValue.current);
    }
  });

  useEffect(() => {
    const form = ref?.current?.form;
    form?.addEventListener('reset', handleReset);
    return () => {
      form?.removeEventListener('reset', handleReset);
    };
  }, [ref, handleReset]);
}
